import React, { Component } from 'react';
import { Modal, Button } from "react-bootstrap"
import { withTranslation } from 'react-i18next';

class LanguageItemDeleteConfirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            transPage: "modals.language_item_delete."
        }

        this.deleteLanguageItem = this.deleteLanguageItem.bind(this)
        this.onOpenModal = this.onOpenModal.bind(this)
        // this.onHideModal = this.onHideModal.bind(this)
    }

    deleteLanguageItem() {
        // dari props method nya
        this.props.deleteLanguageItem() 
    }

    onOpenModal() {
        //console.log("modal open")
    }

    
    render() {
        const {t} = this.props;
       
        // const language_item = 

        return (
            <Modal show={this.props.show} onHide={() => this.props.onHide()} onShow={() => this.onOpenModal()}>
               
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title>{t(this.state.transPage + "title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t(this.state.transPage + "confirmation_text")}</p>
                    
                    
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.onHide()}>
                        {t('cancel')}
                    </Button>
                    <Button variant="danger" onClick={() => this.deleteLanguageItem()}>
                        <i className="fa fa-trash">&nbsp;</i>
                        {t(this.state.transPage + "delete_language_button")}
                    </Button>   
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withTranslation()(LanguageItemDeleteConfirm);